/* eslint-disable no-shadow */
export enum RoutesEnum {
  // Doctors Pages
  HOME_DOCTOR = '/doctors/home',
  LIST_CONTESTS_VACANCIES_DOCTOR = '/doctors/listContestsVacancies',
  CONTESTS_DOCTOR = '/doctors/contests',
  VACANCIES_DOCTOR = '/doctors/vacancies',
  PROFILE_DOCTOR = '/doctors/profile',
  EDIT_ADDRESS_DOCTOR = '/doctors/profile/editAddress',
  EDIT_HEADER_DATA_DOCTOR = '/doctors/profile/editHeaderData',
  EDIT_AVAILABILITY_DOCTOR = '/doctors/profile/editAvailability',
  REQUESTS_DOCTOR = '/doctors/solicitacoes',
  HIRING_DOCTOR = '/doctors/contracts',
  CHATS_DOCTOR = '/doctors/chats',
  CONTRACTOR_DOCTOR = '/doctors/contractor/:id',
  SIGNUP_DOCTOR = '/signup/doctor',
  SIGNUP2_DOCTOR = '/signup2/doctor',
  SIGNUP3_DOCTOR = '/signup3/doctor',
  SIGNUP4_DOCTOR = '/signup4/doctor',
  TERMS_DOCTOR = '/terms/doctor',

  // Contractors Pages
  HOME_CONTRACTOR = '/contractors/home',
  DOCTOR_CONTRACTOR = '/contractors/doctor/:id',
  RECENT_CONTACTS_CONTRACTOR = '/contractors/contacts',
  CONTRACTS_CONTRACTOR = '/contractors/contracts',
  RESULT_CONTRACTOR = '/contractors/result',
  PROFILE_CONTRACTOR = '/contractors/profile',
  EDIT_HEADER_CONTRACTOR = '/contractors/profile/edit-header',
  CHATS_CONTRACTOR = '/contractors/chats',
  SIGNUP_CONTRACTOR = '/signup/contractor',
  SIGNUP2_CONTRACTOR = '/signup2/contractor',
  SIGNUP3_CONTRACTOR = '/signup3/contractor',
  SIGNUP4_CONTRACTOR = '/signup4/contractor',
  TERMS_CONTRACTOR = '/terms/contractor',

  // Common Pages
  CONFIRM_ACCOUNT = '/confirm-account/:email',
  FAQ = '/faq/:type',
  NOTIFICATIONS = '/notifications/:type',
  CHAT = '/chat/:interlocutorType/:interlocutorId',
  PLANS = '/plans/:type',
  CHECKOUT = '/checkout/:type/:id',
  EDIT_PROFILE_IMAGE = '/edit-profile-image/:userType',
  SIGNIN = '/signin',
  FORGOT_PASSWORD = '/forgot-password',
  RECOVERY_PASSWORD = '/recovery-password',
  INTRO = '/intro',
  PRIVACY_POLICY = '/privacyPolice',
  CHANGE_PASSWORD = '/change-password',
  INTRO_DOCTOR = '/intro/doctors',
  INTRO_CONTRACTOR = '/intro/contractors',
}
